// UI strings for the dashboard. Arabic is Modern Standard, kept short so it fits
// the same tiles as the English; digits stay Western, as Egypt writes them.

const STRINGS = {
  en: {
    dir: 'ltr',
    locale: 'en',
    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

    'tile.temperature': 'Temperature',
    'tile.condition': 'Condition',
    'tile.wind': 'Wind',
    'tile.humidity': 'Humidity',
    'tile.pressure': 'Pressure',
    'tile.chart': 'Temperature · 24 h',
    'tile.forecast': 'Forecast',
    'tile.radar': 'Radar',
    'tile.airQuality': 'Air quality',
    'tile.uv': 'UV index',
    'tile.sun': 'Sun',
    'tile.moon': 'Moon',
    'tile.advisories': 'Advisories',

    'meta.code': 'Code {code}',
    'meta.rh': 'RH',
    'meta.msl': 'MSL',
    'meta.hourly': 'Hourly · °{unit} · Shaded = night',
    'meta.days': '{count} days',
    'meta.day': '{count} day',
    'meta.peak': 'Peak {time}',
    'meta.today': 'Today',
    'meta.daylight': 'Daylight {length}',
    'meta.illum': 'Illum {percent}%',
    'meta.ruleBased': 'Rule-based',
    'meta.usEpa': 'US EPA',
    'meta.noData': 'No data',
    'meta.offline': 'Offline',

    'label.feels': 'Feels',
    'label.feelsShort': 'feels',
    'label.dew': 'Dew',
    'label.dewPoint': 'Dew point',
    'label.cloud': 'Cloud',
    'label.rain': 'Rain',
    'label.vis': 'Vis',
    'label.visibility': 'Visibility',
    'label.gust': 'Gust',
    'label.burnTime': 'Burn time',
    'label.protect': 'Protect',
    'label.rise': 'Rise',
    'label.set': 'Set',
    'label.elapsed': 'Elapsed',
    'label.night': 'Night',
    'label.maxWind': 'Max wind',
    'label.precip': 'Precip',
    'label.humidity': 'Humidity',
    'label.moon': 'Moon',
    'label.day': 'Day',
    'label.cond': 'Cond',
    'label.lo': 'Lo',
    'label.hi': 'Hi',
    'label.uv': 'UV',
    'label.now': 'Now',
    'label.today': 'Today',
    'label.dayTime': 'Day',
    'label.nightTime': 'Night',

    'status.connecting': 'Connecting…',
    'status.fetching': 'Fetching…',
    'status.local': 'local',
    'status.updated': 'Updated {time}',
    'status.next': 'Next {time}',
    'status.offline': 'Offline · {age}',

    'time.justNow': 'just now',
    'time.minutes': '{count} min ago',
    'time.hours': '{count} h ago',
    'time.yesterday': 'yesterday',
    'time.days': '{count} days ago',
    'time.unknown': 'a while ago',

    'offline.banner': 'No connection — showing the reading from {age}',
    'offline.firstRun':
      'This is the first visit without a connection, so there is nothing saved to show yet. Reconnect and try again.',
    'offline.title': 'No connection',
    'offline.radar': 'The radar map needs a connection.',
    'offline.search': 'No connection — finding new cities needs the internet. Saved places still work.',

    'error.title': 'Connection error',
    'error.body': 'The weather service did not respond.',
    'error.retry': 'Retry',
    'error.dismiss': 'Dismiss',

    'search.placeholder': 'Search city',
    'search.aria': 'Search for a city',
    'search.recent': 'Recent',
    'search.results': 'Results',
    'search.empty': 'No places match “{query}”',
    'search.short': 'Type at least 2 characters',

    'places.title': 'Places',
    'places.empty': 'No saved places yet. Add one by searching for a city, or by picking a spot on the map.',
    'places.search': 'Search',
    'places.map': 'Pick on map',
    'places.default': 'Default',
    'places.setDefault': 'Make this the default place',
    'places.remove': 'Remove',
    'places.note': 'The house icon sets the place the dashboard opens on. Click a row to show its weather.',
    'places.open': 'Saved places',

    'map.title': 'Pick a place on the map',
    'map.hint': 'Click anywhere on the map',
    'map.myLocation': 'My location',
    'map.save': 'Save place',
    'map.none': 'No place chosen',
    'map.lookingUp': 'Looking up…',
    'map.pin': 'Dropped pin',
    'map.close': 'Close map',

    'settings.title': 'Settings',
    'settings.theme': 'Theme',
    'settings.dark': 'Dark',
    'settings.light': 'Light',
    'settings.temperature': 'Temperature',
    'settings.windSpeed': 'Wind speed',
    'settings.distance': 'Distance',
    'settings.pressure': 'Pressure',
    'settings.clock': 'Clock',
    'settings.hours24': '24 h',
    'settings.hours12': '12 h',
    'settings.language': 'Language',
    'settings.locate': 'Use my current location',
    'settings.close': 'Close settings',

    'header.save': 'Save',
    'header.saved': 'Saved',
    'header.theme': 'Toggle light or dark theme',
    'header.locate': 'Use my current location',
    'header.settings': 'Open settings',

    'alert.tag': 'Alert',
    'alert.details': 'Details',
    'alert.hide': 'Hide',
    'alert.title': 'Weather alert',
    'alert.until': 'until {time}',
    'alert.from': 'From {date}',
    'alert.more': '+{count} more',

    'radar.play': 'Play radar loop',
    'radar.pause': 'Pause radar loop',
    'radar.opacity': 'Opacity {percent}%',
    'radar.unavailable': 'Radar frames unavailable',
    'radar.source': 'RainViewer',

    'notice.locationDenied': 'Location access was blocked. Search for a city instead.',
    'notice.locationUnsupported': 'This browser cannot share your location.',

    'footer.source': 'Src weatherapi.com · Radar rainviewer · Map OSM',

    'cond.clear': 'Clear sky',
    'cond.partly': 'Partly cloudy',
    'cond.cloudy': 'Cloudy',
    'cond.fog': 'Foggy',
    'cond.rain': 'Rainy',
    'cond.snow': 'Snowy',
    'cond.sleet': 'Wintry mix',
    'cond.thunder': 'Thunderstorms',
    'cond.dust': 'Dust and sand',

    'aqi.1': 'Good',
    'aqi.2': 'Moderate',
    'aqi.3': 'Unhealthy for sensitive groups',
    'aqi.4': 'Unhealthy',
    'aqi.5': 'Very unhealthy',
    'aqi.6': 'Hazardous',
    'aqiAdvice.1': 'Air quality is satisfactory, with little or no risk.',
    'aqiAdvice.2': 'Sensitive groups: limit prolonged outdoor exertion.',
    'aqiAdvice.3': 'Children, older adults and people with lung conditions should reduce outdoor activity.',
    'aqiAdvice.4': 'Everyone may feel effects. Avoid prolonged outdoor exertion.',
    'aqiAdvice.5': 'Health alert: stay indoors when possible.',
    'aqiAdvice.6': 'Emergency conditions. Avoid all outdoor activity.',

    'uv.low': 'Low',
    'uv.moderate': 'Moderate',
    'uv.high': 'High',
    'uv.veryHigh': 'Very high',
    'uv.extreme': 'Extreme',
    'uvBurn.30': '30+ min',
    'uvBurn.20': '~20 min',
    'uvBurn.12': '~12 min',
    'uvBurn.6': '~6 min',
    'uvBurn.5': '<5 min',
    'uvProtect.none': 'None needed',
    'uvProtect.spf30': 'SPF 30+',
    'uvProtect.spf30midday': 'SPF 30+ · 11–16',
    'uvProtect.spf50midday': 'SPF 50+ · 11–16',

    'advTag.wear': 'Wear',
    'advTag.uv': 'UV',
    'advTag.rain': 'Rain',
    'advTag.comfort': 'Comfort',
    'advTag.storm': 'Storm',
    'advTag.snow': 'Snow',
    'advTag.wind': 'Wind',
    'advTag.dust': 'Dust',
    'advTag.outdoor': 'Outdoor',

    'wear.veryHot': 'Tank top, shorts and open shoes — it is very hot.',
    'wear.hot': 'Short sleeves and light fabrics.',
    'wear.mild': 'A light jacket or long sleeves feels right.',
    'wear.cool': 'A warm coat, sweater and closed shoes.',
    'wear.cold': 'Heavy winter coat, hat, scarf and gloves.',
    'wear.freezing': 'Insulated gear — extreme cold. Layer up fully.',

    'rain.high': 'High rain chance — take an umbrella.',
    'rain.some': 'Some rain possible — a compact umbrella is smart.',

    'activity.dust': 'Dust in the air — keep windows shut and wear a mask outdoors.',
    'activity.storm': 'Thunderstorms — postpone outdoor activities.',
    'activity.snow': 'Snow/ice — drive carefully, dress warm.',
    'activity.heavyRain': 'Heavy rain — indoor plan recommended.',
    'activity.rain': 'Rain likely — bring gear if heading out.',
    'activity.extremeUv': 'Extreme UV — sunscreen SPF 50+, avoid midday sun.',
    'activity.highUv': 'High UV — wear SPF 30+ and sunglasses.',
    'activity.veryWindy': 'Very windy — caution near trees and scaffolding.',
    'activity.breezy': 'Breezy — great for kites, harder for cycling.',
    'activity.pleasant': 'Pleasant — a great day to be outdoors.',
    'activity.ok': 'A decent day for light outdoor activity.',

    'comfort.muggy': 'Hot and muggy — feels stickier than the reading.',
    'comfort.warmer': 'Feels warmer than the actual temperature.',
    'comfort.colder': 'Wind chill makes it feel noticeably colder.',
    'comfort.humid': 'Moderately humid — comfortable but a little sticky.',
    'comfort.fine': 'Comfortable humidity levels.',

    'moon.Moon': 'Moon',
    'moon.New Moon': 'New moon',
    'moon.Waxing Crescent': 'Waxing crescent',
    'moon.First Quarter': 'First quarter',
    'moon.Waxing Gibbous': 'Waxing gibbous',
    'moon.Full Moon': 'Full moon',
    'moon.Waning Gibbous': 'Waning gibbous',
    'moon.Last Quarter': 'Last quarter',
    'moon.Waning Crescent': 'Waning crescent',
  },

  ar: {
    dir: 'rtl',
    locale: 'ar',
    days: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    months: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],

    'tile.temperature': 'درجة الحرارة',
    'tile.condition': 'الحالة',
    'tile.wind': 'الرياح',
    'tile.humidity': 'الرطوبة',
    'tile.pressure': 'الضغط',
    'tile.chart': 'الحرارة · 24 ساعة',
    'tile.forecast': 'التوقعات',
    'tile.radar': 'الرادار',
    'tile.airQuality': 'جودة الهواء',
    'tile.uv': 'مؤشر UV',
    'tile.sun': 'الشمس',
    'tile.moon': 'القمر',
    'tile.advisories': 'إرشادات',

    'meta.code': 'كود {code}',
    'meta.rh': 'رطوبة',
    'meta.msl': 'سطح البحر',
    'meta.hourly': 'كل ساعة · °{unit} · المظلل = ليل',
    'meta.days': '{count} أيام',
    'meta.day': 'يوم واحد',
    'meta.peak': 'الذروة {time}',
    'meta.today': 'اليوم',
    'meta.daylight': 'النهار {length}',
    'meta.illum': 'الإضاءة {percent}%',
    'meta.ruleBased': 'قواعد',
    'meta.usEpa': 'US EPA',
    'meta.noData': 'لا بيانات',
    'meta.offline': 'غير متصل',

    'label.feels': 'الإحساس',
    'label.feelsShort': 'إحساس',
    'label.dew': 'الندى',
    'label.dewPoint': 'نقطة الندى',
    'label.cloud': 'الغيوم',
    'label.rain': 'المطر',
    'label.vis': 'الرؤية',
    'label.visibility': 'مدى الرؤية',
    'label.gust': 'هبّات',
    'label.burnTime': 'زمن الحروق',
    'label.protect': 'الحماية',
    'label.rise': 'الشروق',
    'label.set': 'الغروب',
    'label.elapsed': 'المنقضي',
    'label.night': 'ليل',
    'label.maxWind': 'أقصى رياح',
    'label.precip': 'الهطول',
    'label.humidity': 'الرطوبة',
    'label.moon': 'القمر',
    'label.day': 'اليوم',
    'label.cond': 'الحالة',
    'label.lo': 'الصغرى',
    'label.hi': 'العظمى',
    'label.uv': 'UV',
    'label.now': 'الآن',
    'label.today': 'اليوم',
    'label.dayTime': 'نهار',
    'label.nightTime': 'ليل',

    'status.connecting': 'جارٍ الاتصال…',
    'status.fetching': 'جارٍ التحديث…',
    'status.local': 'محلي',
    'status.updated': 'حُدّث {time}',
    'status.next': 'التالي {time}',
    'status.offline': 'غير متصل · {age}',

    'time.justNow': 'الآن',
    'time.minutes': 'قبل {count} دقيقة',
    'time.hours': 'قبل {count} ساعة',
    'time.yesterday': 'أمس',
    'time.days': 'قبل {count} أيام',
    'time.unknown': 'منذ فترة',

    'offline.banner': 'لا يوجد اتصال — تُعرض قراءة {age}',
    'offline.firstRun': 'هذه أول زيارة بدون اتصال، فلا توجد بيانات محفوظة بعد. أعد الاتصال وحاول مرة أخرى.',
    'offline.title': 'لا يوجد اتصال',
    'offline.radar': 'خريطة الرادار تحتاج اتصالًا بالإنترنت.',
    'offline.search': 'لا يوجد اتصال — البحث عن مدن جديدة يحتاج الإنترنت. الأماكن المحفوظة تعمل.',

    'error.title': 'خطأ في الاتصال',
    'error.body': 'لم تستجب خدمة الطقس.',
    'error.retry': 'إعادة المحاولة',
    'error.dismiss': 'إغلاق',

    'search.placeholder': 'ابحث عن مدينة',
    'search.aria': 'ابحث عن مدينة',
    'search.recent': 'الأخيرة',
    'search.results': 'النتائج',
    'search.empty': 'لا توجد أماكن تطابق «{query}»',
    'search.short': 'اكتب حرفين على الأقل',

    'places.title': 'الأماكن',
    'places.empty': 'لا توجد أماكن محفوظة بعد. أضف مكانًا بالبحث عن مدينة، أو باختيار نقطة على الخريطة.',
    'places.search': 'بحث',
    'places.map': 'اختر من الخريطة',
    'places.default': 'افتراضي',
    'places.setDefault': 'اجعله المكان الافتراضي',
    'places.remove': 'حذف',
    'places.note': 'أيقونة المنزل تحدد المكان الذي تفتح عليه اللوحة. اضغط على أي صف لعرض طقسه.',
    'places.open': 'الأماكن المحفوظة',

    'map.title': 'اختر مكانًا على الخريطة',
    'map.hint': 'اضغط على أي نقطة في الخريطة',
    'map.myLocation': 'موقعي',
    'map.save': 'حفظ المكان',
    'map.none': 'لم يتم اختيار مكان',
    'map.lookingUp': 'جارٍ التعرف…',
    'map.pin': 'نقطة محددة',
    'map.close': 'إغلاق الخريطة',

    'settings.title': 'الإعدادات',
    'settings.theme': 'المظهر',
    'settings.dark': 'داكن',
    'settings.light': 'فاتح',
    'settings.temperature': 'الحرارة',
    'settings.windSpeed': 'سرعة الرياح',
    'settings.distance': 'المسافة',
    'settings.pressure': 'الضغط',
    'settings.clock': 'الساعة',
    'settings.hours24': '24 ساعة',
    'settings.hours12': '12 ساعة',
    'settings.language': 'اللغة',
    'settings.locate': 'استخدم موقعي الحالي',
    'settings.close': 'إغلاق الإعدادات',

    'header.save': 'حفظ',
    'header.saved': 'محفوظ',
    'header.theme': 'تبديل المظهر الفاتح والداكن',
    'header.locate': 'استخدم موقعي الحالي',
    'header.settings': 'فتح الإعدادات',

    'alert.tag': 'تحذير',
    'alert.details': 'التفاصيل',
    'alert.hide': 'إخفاء',
    'alert.title': 'تحذير جوي',
    'alert.until': 'حتى {time}',
    'alert.from': 'من {date}',
    'alert.more': '+{count} أخرى',

    'radar.play': 'تشغيل حلقة الرادار',
    'radar.pause': 'إيقاف حلقة الرادار',
    'radar.opacity': 'الشفافية {percent}%',
    'radar.unavailable': 'لقطات الرادار غير متاحة',
    'radar.source': 'RainViewer',

    'notice.locationDenied': 'تم منع الوصول إلى الموقع. ابحث عن مدينة بدلًا من ذلك.',
    'notice.locationUnsupported': 'هذا المتصفح لا يدعم مشاركة الموقع.',

    'footer.source': 'المصدر weatherapi.com · الرادار rainviewer · الخريطة OSM',

    'cond.clear': 'سماء صافية',
    'cond.partly': 'غيوم جزئية',
    'cond.cloudy': 'غائم',
    'cond.fog': 'ضباب',
    'cond.rain': 'ممطر',
    'cond.snow': 'ثلوج',
    'cond.sleet': 'مزيج شتوي',
    'cond.thunder': 'عواصف رعدية',
    'cond.dust': 'أتربة ورمال',

    'aqi.1': 'جيدة',
    'aqi.2': 'متوسطة',
    'aqi.3': 'غير صحية للفئات الحساسة',
    'aqi.4': 'غير صحية',
    'aqi.5': 'غير صحية جدًا',
    'aqi.6': 'خطرة',
    'aqiAdvice.1': 'جودة الهواء مُرضية، والخطر ضئيل أو معدوم.',
    'aqiAdvice.2': 'الفئات الحساسة: قلّل المجهود الخارجي الطويل.',
    'aqiAdvice.3': 'على الأطفال وكبار السن وأصحاب أمراض الرئة تقليل النشاط الخارجي.',
    'aqiAdvice.4': 'قد يشعر الجميع بالتأثير. تجنّب المجهود الخارجي الطويل.',
    'aqiAdvice.5': 'تحذير صحي: ابقَ في الداخل قدر الإمكان.',
    'aqiAdvice.6': 'ظروف طارئة. تجنّب أي نشاط خارجي.',

    'uv.low': 'منخفض',
    'uv.moderate': 'متوسط',
    'uv.high': 'عالٍ',
    'uv.veryHigh': 'عالٍ جدًا',
    'uv.extreme': 'شديد',
    'uvBurn.30': '30+ دقيقة',
    'uvBurn.20': '~20 دقيقة',
    'uvBurn.12': '~12 دقيقة',
    'uvBurn.6': '~6 دقائق',
    'uvBurn.5': 'أقل من 5 دقائق',
    'uvProtect.none': 'غير مطلوبة',
    'uvProtect.spf30': 'SPF 30+',
    'uvProtect.spf30midday': 'SPF 30+ · 11–16',
    'uvProtect.spf50midday': 'SPF 50+ · 11–16',

    'advTag.wear': 'الملابس',
    'advTag.uv': 'الأشعة',
    'advTag.rain': 'المطر',
    'advTag.comfort': 'الراحة',
    'advTag.storm': 'عواصف',
    'advTag.snow': 'ثلوج',
    'advTag.wind': 'رياح',
    'advTag.dust': 'أتربة',
    'advTag.outdoor': 'بالخارج',

    'wear.veryHot': 'قميص خفيف وشورت وحذاء مفتوح — الجو حار جدًا.',
    'wear.hot': 'أكمام قصيرة وأقمشة خفيفة.',
    'wear.mild': 'جاكيت خفيف أو أكمام طويلة.',
    'wear.cool': 'معطف دافئ وسويتر وحذاء مغلق.',
    'wear.cold': 'معطف شتوي ثقيل وقبعة ووشاح وقفازات.',
    'wear.freezing': 'ملابس معزولة — برد قارس. طبقات كاملة.',

    'rain.high': 'احتمال مطر كبير — خذ مظلة.',
    'rain.some': 'احتمال مطر — مظلة صغيرة فكرة جيدة.',

    'activity.dust': 'أتربة في الجو — أغلق النوافذ وارتدِ كمامة بالخارج.',
    'activity.storm': 'عواصف رعدية — أجّل الأنشطة الخارجية.',
    'activity.snow': 'ثلوج أو جليد — قُد بحذر والبس ملابس دافئة.',
    'activity.heavyRain': 'مطر غزير — يُفضّل خطة داخلية.',
    'activity.rain': 'المطر مُرجّح — خذ معك ما يلزم.',
    'activity.extremeUv': 'أشعة شديدة — واقٍ شمسي SPF 50+ وتجنّب شمس الظهيرة.',
    'activity.highUv': 'أشعة عالية — استخدم SPF 30+ ونظارة شمسية.',
    'activity.veryWindy': 'رياح قوية جدًا — احذر قرب الأشجار والسقالات.',
    'activity.breezy': 'نسيم قوي — ممتاز للطائرات الورقية، أصعب للدراجات.',
    'activity.pleasant': 'جو لطيف — يوم مناسب للخروج.',
    'activity.ok': 'يوم مقبول لنشاط خارجي خفيف.',

    'comfort.muggy': 'حار ورطب — الإحساس أثقل من القراءة.',
    'comfort.warmer': 'الإحساس أدفأ من درجة الحرارة الفعلية.',
    'comfort.colder': 'الرياح تجعل الجو يبدو أبرد بوضوح.',
    'comfort.humid': 'رطوبة متوسطة — مريحة لكن لزجة قليلًا.',
    'comfort.fine': 'مستويات رطوبة مريحة.',

    'moon.Moon': 'القمر',
    'moon.New Moon': 'محاق',
    'moon.Waxing Crescent': 'هلال متزايد',
    'moon.First Quarter': 'التربيع الأول',
    'moon.Waxing Gibbous': 'أحدب متزايد',
    'moon.Full Moon': 'بدر',
    'moon.Waning Gibbous': 'أحدب متناقص',
    'moon.Last Quarter': 'التربيع الأخير',
    'moon.Waning Crescent': 'هلال متناقص',
  },
}

export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'ar', label: 'العربية' },
]

export const isRtl = language => STRINGS[language]?.dir === 'rtl'

export function translator(language) {
  const table = STRINGS[language] || STRINGS.en
  const fallback = STRINGS.en
  return (key, params) => {
    let text = table[key] ?? fallback[key] ?? key
    if (params) {
      Object.entries(params).forEach(([name, value]) => {
        text = text.replace(new RegExp(`\\{${name}\\}`, 'g'), String(value))
      })
    }
    return text
  }
}

export const calendar = language => {
  const table = STRINGS[language] || STRINGS.en
  return { days: table.days, months: table.months, locale: table.locale }
}

export default STRINGS
